import { AfterViewChecked, AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SharedService } from '../../../shared/services/shared.service';
import { Title } from '@angular/platform-browser';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-legal-policy',
  templateUrl: './legal-policy.component.html',
  styleUrls: ['./legal-policy.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LegalPolicyComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  legalPolicyColorList = {
    footerIconColor: '#866D4B', footerHoverColor: '#F5F2ED', footerFillColor: '#FFFFFF', headerDataHoverColor: "#976841"
  }

  tabName: any;
  routeState: any;
  subscription: any;
  legalPageData: any;
  isActive: boolean = false;
  page: any;
  mobileTabname: any;
  tabDisplayName: string;
  currentTabDetails: any;
  @ViewChildren('tabContentRef', { read: ElementRef }) tabContents!: QueryList<ElementRef>;

  private listeners: (() => void)[] = [];

  constructor(private sanitizer: DomSanitizer, private router: Router, public _sharedService: SharedService, private route: ActivatedRoute,private title : Title) {
    this.router.events.subscribe(event => {
      this.page = this.route.snapshot.data['page']
      if (event instanceof NavigationEnd) {
        if (this.route.snapshot.queryParams['tab']) {
          this.route.queryParams.subscribe((queryParams: any) => {
            this.tabName = this.route.snapshot.queryParams['tab']
            // if(this.tabName == 'privacy'){
            //   this.mobileTabname = this.tabDisplayName = 'PRIVACY POLICY'
            //   this.route.snapshot.data["CTLinkClicked"] = 'Legal Privacy Policy';
            // } else if(this.tabName == 'terms') {
            //   this.mobileTabname = this.tabDisplayName = 'TERMS & CONDITIONS'
            //   this.route.snapshot.data["CTLinkClicked"] = 'Legal Terms & Conditions';
            // } else {
            //   // this.route.snapshot.data["CTLinkClicked"] = 'Legal';
            //   this.tabName = 'terms';
            //   this.mobileTabname = this.tabDisplayName = 'TERMS & CONDITIONS'
            //   this.route.snapshot.data["CTLinkClicked"] = 'Legal Terms & Conditions';
            // }
          });
        } else {
          // this.tabName = 'terms';
          // this.mobileTabname = this.tabDisplayName = 'TERMS & CONDITIONS'
          // this.route.snapshot.data["CTLinkClicked"] = 'Legal Terms & Conditions';
        }
      }
    })
  }

  ngOnInit() {
    this.loadPdfJsScripts(); // Preload PDF.js scripts
    this.getLegalPageContent();
    this.title.setTitle('Legal Policies| Jio World Centre - Mumbai');
  }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (
      event.key === 'F12' ||
      (event.ctrlKey && (event.key === 'u' || event.key === 'p' || event.key === 's')) ||
      (event.ctrlKey && event.shiftKey && ['I', 'J', 'C'].includes(event.key))
    ) {
      event.preventDefault();
    }
  }

  ngAfterViewInit() {
    this.addListeners();
  }

  ngAfterViewChecked() {
    // Because *ngIf or data change may cause DOM re-render, update listeners
    this.addListeners();
  }

  private addListeners() {
    // Clear previous listeners to avoid duplicates
    this.listeners.forEach(unlisten => unlisten());
    this.listeners = [];
  
    this.tabContents.forEach(tabRef => {
      const nativeEl = tabRef.nativeElement as HTMLElement;
  
      // Add click listener on each tab div
      const listener = (event: Event) => {
        const target = event.target as HTMLElement;
        const anchor = target.closest('a') as HTMLAnchorElement;
  
        if (anchor) {
          const href = anchor.href;
  
          // Skip if href is Google Drive or ril.com
          if (
            href.includes('www.drive.google.com') || 
            href.includes('www.ril.com')
          ) {
            return; // Don't handle these links
          }
  
          // Prevent default behavior for other links
          event.preventDefault();
  
          if (href) {
            this.router.navigate(['/pdf-viewer'], { queryParams: { file: encodeURIComponent(href) } });
          }
        }
      };
  
      nativeEl.addEventListener('click', listener);
  
      // Save function to remove listener later
      this.listeners.push(() => nativeEl.removeEventListener('click', listener));
    });
  }
  

  ngOnDestroy() {
    // Clean up listeners
    this.listeners.forEach(unlisten => unlisten());
  }

  sanitizeHtml(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content || '');
  }



  getLegalPageContent() {
    this.subscription = this._sharedService.getCommonService().getlandingData(170901).subscribe(
      (data: any) => {
        this.legalPageData = data ? data.data.cards : data;

        // Map for local PDF paths
        const pdfMap = {
          'COD': '/assets/pdfs/JWC Code of Conduct.pdf'
        };

        // Replace external URLs with local paths for specific TabIdentifiers
        this.legalPageData.forEach(card => {
          const tabId = card.TabIdentifier.data;
          if (pdfMap[tabId]) {
            card.LegalTabContent.data = card.LegalTabContent.data.replace(/href="[^"]*"/, `href="${pdfMap[tabId]}"`);
          }
        });

        this._sharedService.initializeCustomJs();
        this._sharedService.callsidebarDrop();
        // console.log("this.legalPageData: ", this.legalPageData);
        this.currentTabDetails = this.tabName ? this.legalPageData.find((item)=> item.TabIdentifier.data === this.tabName) : (this.legalPageData[0] || undefined);

        if(this.currentTabDetails){
          this.mobileTabname = this.tabDisplayName = this.currentTabDetails.LegalTabName.data || '';
        }

        //this.changeTabName(this.tabName, this.tabDisplayName)

      },
      (error) => {
        console.log("Try after some time..");
      }
    )
  }

  changeTabName(tabId, tabname) {
    this.mobileTabname = tabname;
    this.router.navigate([], {
      relativeTo: this.route, queryParams: { tab: tabId }, // queryParamsHandling: 'merge', // remove to replace all query params by provided
    });
  }

  callLegalCTEvent(tabName) {
    this._sharedService.callCTEvent('Section_Primary_Links','', '', tabName);
  } 

  sanitizeId(value: string): string {
    return value
      ?.replace(/<[^>]*>/g, '')           // Remove HTML tags
      .toLowerCase()
      .trim()
      .replace(/[\s_]+/g, '-')            // Replace spaces/underscores with dashes
      .replace(/[^a-z0-9-]/g, '')         // Remove all non-alphanumeric except dashes
      .replace(/-+/g, '-');               // Collapse multiple dashes
  }

  getFragmentId(val){
    return val.replace(/\s/g, '-').toLowerCase();
  }
  
  scrollToSection(title: string): void {
    const fragmentId = this.getFragmentId(title);
    const element = document.getElementById(fragmentId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  loadPdfJsScripts(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any)['pdfjsLib']) {
        console.log('pdfjsLib already loaded');
        resolve();
        return;
      }

      const script1 = document.createElement('script');
      script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js';

      script1.onload = () => {
        console.log('pdf.min.js loaded successfully');

        try {
          (window as any)['pdfjsLib'].GlobalWorkerOptions.workerSrc =
            'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
          console.log('workerSrc set:', (window as any)['pdfjsLib'].GlobalWorkerOptions.workerSrc);
        } catch (e) {
          console.error('Error setting workerSrc:', e);
          reject(e);
          return;
        }

        resolve();
      };

      script1.onerror = (err) => {
        console.error('Error loading pdf.min.js script:', err);
        reject(err);
      };

      console.log('Starting to load pdf.min.js script...');
      document.body.appendChild(script1);
    });
  }

}
